import { Box, Container, Typography } from "@mui/material"
import CertificateTable from "../components/CertificateTable"
import { usePageTitle } from "../hooks/TitleHook"
import { usePartnerAtomValue } from "../hooks/PartnerHooks"
import { useAtomValue } from "jotai"
import { userAtom } from "../atoms/user"

const Certificates = () => {
	usePageTitle("BlueHalo - Offset Retirement Certificates")
	const partner = usePartnerAtomValue()
	const user = useAtomValue(userAtom)

	// For admin users, only show content if partner is selected
	// For non-admin users, always show content
	const shouldShowContent = user.isAdmin ? Boolean(partner) : true

	return (
		<Box>
			<Container sx={{ ml: -3, mb: 1 }}>
				<Typography variant="h3" textAlign="start" className="txt-main m-b-0">
					Offset Retirement Certificates
				</Typography>
			</Container>
			{shouldShowContent && <CertificateTable />}
		</Box>
	)
}

export default Certificates
